import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isAccessTokenValid } from "../utils/validateToken";
import { useDispatch, useSelector } from "react-redux";
import ProfileMenu from "./ProfileMenu";
import { ROUTES } from "../router/appRoutes";
import { authAxios } from "../utils/axiosConfig";
import { logout } from "../redux/authSlice";

const MobileMenu = ({ setIsOpen, className }) => {
	const { isLoggedIn, accessToken } = useSelector((state) => state.auth);
	const isTokenValid = isAccessTokenValid(accessToken);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	
	const toggleMenu = () => setIsOpen((prevIsOpen) => !prevIsOpen);
	

	const handleHome = () => {
		navigate(ROUTES.HOME), setIsOpen((open) => !open), className("hamburger_close");
	};

	const handleProjects = () => {
		navigate(ROUTES.PROJECTS),
			setIsOpen((open) => !open),
			className("hamburger_close");
	};

	const handleDashboard = () => {
		navigate(ROUTES.DASHBOARD),
			setIsOpen((open) => !open),
			className("hamburger_close");
	};

	const handleBlogs = () => {
		navigate(ROUTES.BLOGS),
			setIsOpen((open) => !open),
			className("hamburger_close");
	};

	const handleContact = () => {
		navigate(ROUTES.CONTACT),
			setIsOpen((open) => !open),
			className("hamburger_close");
	};
	
	const handleLogin = () => {
		navigate(ROUTES.LOGIN),
			setIsOpen((open) => !open),
			className("hamburger_close");
	};
	
	const handleLogout = async (e) => {
		try {
			e.preventDefault();
			const res = await authAxios.post("/api/auth/logout");
			// console.log(res);
			
			if (res.status !== 200) {
				throw new Error("Logout Error")
			}
			
			await dispatch(logout());
			navigate(ROUTES.LOGIN);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<ul className="mobile_menu">
			{isTokenValid && isLoggedIn && (
				<li>
					<ProfileMenu
						// isMobileMenuOpen={setIsOpen}
						className={className}
						onClick={handleDashboard}
					/>
				</li>
			)}
			<li onClick={handleHome}>Home</li>
			<li onClick={handleProjects}>Projects</li>
			<li onClick={handleContact}>Contact</li>
			{/* <li onClick={handleBlogs}>Blogs</li> */}
			
			{isLoggedIn 
				?	<li onClick={handleLogout}>Logout</li>
				:	<li onClick={handleLogin}>Login</li>
			}
		</ul>
	);
};

export default MobileMenu;
